if (!customElements.get('bundle-flavor-picker')) {
  class BundleFlavorPicker extends HTMLElement {
    connectedCallback() {
      this.slots = [...this.querySelectorAll('.bundle-picker__slot')];
      this.template = this.querySelector('template[data-bundle-options]');
      this.overlay = this.querySelector('.bundle-picker__overlay');
      this.counter = this.querySelector('[data-bundle-count]');
      this.activeSlot = null;

      this.slots.forEach((slot) => {
        slot.querySelector('.bundle-picker__trigger')
          .addEventListener('click', (e) => {
            e.stopPropagation();
            this.activeSlot === slot ? this.close() : this.open(slot);
          });
      });

      this.overlay.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());
      document.addEventListener('click', (e) => {
        if (this.activeSlot && !this.contains(e.target)) this.close();
      });

      // Gate the product form: block submit until all slots are chosen.
      const firstInput = this.querySelector('[data-bundle-input]');
      this.form = firstInput ? firstInput.form : null;
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          if (!this.isComplete()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.showError();
          }
        }, true); // capture: runs before the theme's product-form fetch handler
      }
      this.updateState();
    }

    open(slot) {
      this.close();
      const sheet = this.template.content.firstElementChild.cloneNode(true);
      const label = slot.querySelector('.bundle-picker__label').textContent;
      const current = slot.querySelector('[data-bundle-input]').value;

      sheet.querySelector('[data-sheet-title]').textContent = label;
      sheet.querySelector('.bundle-picker__sheet-close')
        .addEventListener('click', () => this.close());

      sheet.querySelectorAll('.bundle-picker__option').forEach((opt) => {
        opt.classList.toggle('is-selected', opt.dataset.value === current);
        opt.addEventListener('click', () => this.select(slot, opt));
      });

      slot.appendChild(sheet);
      slot.querySelector('.bundle-picker__trigger').setAttribute('aria-expanded', 'true');
      this.overlay.hidden = false;
      document.documentElement.classList.add('bundle-picker-open');
      this.activeSlot = slot;
    }

    close() {
      if (!this.activeSlot) return;
      this.activeSlot.querySelector('.bundle-picker__sheet')?.remove();
      this.activeSlot.querySelector('.bundle-picker__trigger').setAttribute('aria-expanded', 'false');
      this.overlay.hidden = true;
      document.documentElement.classList.remove('bundle-picker-open');
      this.activeSlot = null;
    }

    select(slot, opt) {
      const input = slot.querySelector('[data-bundle-input]');
      input.value = opt.dataset.value;

      slot.querySelector('[data-slot-value]').textContent = opt.dataset.value;
      slot.classList.remove('is-missing');
      slot.classList.add('is-filled');

      const media = slot.querySelector('[data-slot-media]');
      if (opt.dataset.image) {
        media.innerHTML = `<img src="${opt.dataset.image}" alt="" width="48" height="48">`;
        media.classList.remove('is-empty');
      }
      this.close();
      this.updateState();
    }

    isComplete() {
      return this.slots.every((s) => s.querySelector('[data-bundle-input]').value !== '');
    }

    updateState() {
      const filled = this.slots.filter((s) => s.querySelector('[data-bundle-input]').value !== '').length;
      if (this.counter) this.counter.textContent = `${filled} af ${this.slots.length} valgt`;
      this.form?.querySelector('button[name="add"]')
        ?.classList.toggle('bundle-incomplete', filled < this.slots.length);
    }

    showError() {
      const empty = this.slots.filter((s) => !s.querySelector('[data-bundle-input]').value);
      empty.forEach((s) => s.classList.add('is-missing'));
      empty[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const notice = this.form?.querySelector('.form-notification.error');
      if (notice) {
        notice.textContent = `Vælg venligst alle ${this.slots.length} smage først`;
        notice.style.display = 'flex';
        setTimeout(() => (notice.style.display = 'none'), 4000);
      }
    }
  }
  customElements.define('bundle-flavor-picker', BundleFlavorPicker);
}